<template>
  <ul>
    <li class="title">{{ $t("languages") }}</li>
    <li v-for="item in languages">
      <a
        herf="javascript:void(0)"
        @click="changeLang(item)"
        :class="{ 'current-lang': currentLangCode === item.code }"
      >
        {{ item.text }}
      </a>
    </li>
  </ul>
</template>

<script>
import languages from "../../lib/i18n";
import { funcUrlDel } from "../../lib/utils";

export default {
  name: "choose-lang-in-footer",
  data: function () {
    return {
      languages,
      currentLangCode: "",
    };
  },
  computed: {
    language() {
      return this.$store.state.currentLang;
    },
  },
  locales: {
    zh: {
      languages: "选择语言",
    },
    en: {
      languages: "Languages",
    },
  },
  created() {
    this.getInitLang();
  },
  methods: {
    getInitLang() {
      this.currentLangCode = this.$store.state.currentLang;
    },
    changeLang(lang) {
      this.currentLangCode = lang.code;
      this.$store.commit("setCurrentLang", lang.code);
      window.sessionStorage.setItem("needUseNoCache", true);
      window.location.replace(funcUrlDel("lang"));
    },
  },
};
</script>

<style rel="stylesheet/scss" lang="scss" scoped>
* {
  padding: 0;
  margin: 0;
}

ul {
  min-height: (0.36rem * 5);
  margin-bottom: 0.4rem;
}

li {
  list-style-type: none;
  text-align: left;
  margin-bottom: 16px;
  word-break: break-all;
  &,
  & * {
    font-size: 14px;
    color: #999999;
    letter-spacing: 0;
    line-height: 20px;
    font-weight: 400;
  }
}
li.title {
  color: #666666;
  font-weight: 600;
}

a {
  cursor: pointer;
  // color: #fff;
  // opacity: 0.4;
  &:focus,
  &.active {
    // color: #fff;
  }
  &:hover {
    opacity: 1;
  }
}

@media (max-width: 767px) {
  ul {
    margin-bottom: 40px;
  }
  li {
    margin-bottom: 16px;
  }
  li:last-child {
    margin-bottom: 0;
  }
}
</style>



// WEBPACK FOOTER //
// ChooseLangInFooter.vue?f5145284